import { QueryClient, type DefaultOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

const queryConfig: DefaultOptions = {
  queries: {
    // Smarter refetch: allow focus refetch except for heavy queries
    refetchOnWindowFocus: false,

    // Retry up to 2 times only for 500 errors
    retry: (failureCount, error: Error) => {
      // Check if error has status 500
      if (error instanceof AxiosError) {
        const status = error?.response?.status || error?.status;
        if (status === 500 && failureCount < 2) {
          return true;
        }
      }
      return false;
    },

    // Exponential backoff with jitter (aware of network type)
    retryDelay: attemptIndex => {
      const connection = (
        navigator as unknown as { connection: { effectiveType: string } }
      )?.connection;
      const baseDelay = connection?.effectiveType === '4g' ? 1000 : 3000;
      return Math.min(
        baseDelay * 2 ** attemptIndex + Math.random() * 1000,
        30_000
      );
    },

    networkMode: 'online',
    refetchOnMount: true,
    refetchOnReconnect: true,
    structuralSharing: true,
  },
  mutations: {
    retry: 1,
    networkMode: 'online',
    retryDelay: i => Math.min(1000 * 2 ** i, 5000),
  },
};

// Create query client with optimized configuration
export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
});
